import { useHistory } from "react-router-dom";
import {
  Container,
  ContainerMenu,
  ToolsButton,
  ImgButtonsTools,
  HeaderTitle,
  HeaderPrimaryDiv,
  PrimaryHeading,
  Secondaryeading,
} from "./style";

const ConsultyProducts = ({ dataConsultancy, style, product, unity, setStyle, setProduct, handleBuyConsultancy, linguica, frango, corteFrango, batata }) => {
  const history = useHistory();
  return (
    <Container>
      <ContainerMenu>
        <ToolsButton onClick={() => {   
          if (linguica) {
            setProduct("Linguiça Salsichão")
            setStyle(["selection", "", "", ""])
          } else {
            handleBuyConsultancy("L", 1000)
            setProduct("Linguiça Salsichão")
            setStyle(["selection", "", "", ""])
          }
            
        }}>
          <ImgButtonsTools
            className={style[0]}
            src="./images/sausage_pcp.svg"
            alt="sausage_pcp"
          />
        </ToolsButton>
        <ToolsButton 
        onClick={() => {
          if (frango) {
            setProduct("Frango")
            setStyle(["", "selection", "", ""])
          } else {
            handleBuyConsultancy("F", 1000)
            setProduct("Frango")
            setStyle(["", "selection", "", ""])
          }
        }}>
          <ImgButtonsTools
            className={style[1]}
            src="./images/chicken_pcp.svg"
            alt="chicken_pcp"
          />
        </ToolsButton>
        <ToolsButton 
        onClick={() => {
          if (corteFrango) {
            setProduct("Frango Corte")
            setStyle(["", "", "selection", ""])
          } else {
            handleBuyConsultancy("S", 1000)
            setProduct("Frango Corte")
            setStyle(["", "", "selection", ""])
          }
        }}>
          <ImgButtonsTools
            className={style[2]}
            src="./images/cut_chicken_pcp.svg"
            alt="cut_chicken_pcp"
          />
        </ToolsButton>
        <ToolsButton 
        onClick={() => {
          if (batata) {
            setProduct("Batata")
            setStyle(["", "", "", "selection"])
          } else {
            handleBuyConsultancy("B", 1000)
            setProduct("Batata")
            setStyle(["", "", "", "selection"])
          }
        }}>
          <ImgButtonsTools
            className={style[3]}
            src="./images/fries_pcp.svg"
            alt="fries_pcp"
          />
        </ToolsButton>
      </ContainerMenu>
      {product !== "" &&
      <>
      <HeaderTitle>
        <span>Consultoria</span> <p>{product}</p>
      </HeaderTitle>

      <HeaderPrimaryDiv>
        <PrimaryHeading>
            Potencial de mercado: 
        </PrimaryHeading>
        <Secondaryeading>
        R$   
        {
          product === "Linguiça Salsichão" ?
          dataConsultancy?.potencialLinguica
          :
          product === "Frango" ?
          dataConsultancy?.potencialFrangoCong
          :  
          product === "Frango Corte" ?
          dataConsultancy?.potencialFrangoCorte
          : 
          dataConsultancy?.potencialBatata
        }</Secondaryeading>
      </HeaderPrimaryDiv>
      </>}
    </Container>
  );
};
export default ConsultyProducts;
